import React from 'react';
import { Container } from 'react-bootstrap';

type Props = {
  filterHeader?: React.ReactNode;
  filterBody?: React.ReactNode;
  contentHeader?: React.ReactNode;
  children?: React.ReactNode;
};

// From lg up the filters and the list are two panes side by side that scroll on their own; below it
// the filters come first and the page scrolls both.
export function ContentCloudListPageLayout({ filterHeader, filterBody, contentHeader, children }: Props) {
  return (
    <div className={`d-flex flex-column flex-lg-row justify-content-lg-center align-items-stretch`}>
      <div className="content-cloud-list-filters border-right p-3 pe-4 pt-4 flex-shrink-0 flex-grow-0">
        <div className="h-100 d-flex flex-column">
          <div className="flex-grow-0 flex-shrink-0">{filterHeader}</div>
          <div className="flex-grow-1 flex-shrink-1 overflow-auto">{filterBody}</div>
        </div>
      </div>
      <div className="content-cloud-list-pane flex-shrink-1 flex-grow-1 min-width-0 pt-4">
        <div className="h-100 d-flex flex-column">
          <Container className="flex-grow-0 flex-shrink-0">{contentHeader}</Container>
          <Container className="flex-grow-1 flex-shrink-1 overflow-auto">{children}</Container>
        </div>
      </div>
    </div>
  );
}
